import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ChecksTable from 'dashboard/components/ChecksTable';
import { VerificationDetailProps } from 'dashboard/components/VerificationDetail/types';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { VerificationDatabaseAadhaar } from 'dashboard/models/verification';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { VerificationStatus } from 'lib/verification';

const StyledAttributeGrid = styled(AttributeGrid)`
  padding: 0 ${Spacing[4]} ${Spacing[2]};
`;

interface DatabaseAadhaarVerificationProps extends VerificationDetailProps {
  verification: VerificationDatabaseAadhaar;
}

const DatabaseAadhaarVerification = ({ verification }: DatabaseAadhaarVerificationProps) => {
  const {
    'name-first': nameFirst,
    'name-last': nameLast,
    birthdate,
    status,
    'redacted-at': redactedAt,
  } = verification.attributes;

  const isRedacted = redactedAt != null;

  const hasBeenSubmitted = status !== VerificationStatus.Initiated;

  const checks = verification.attributes.checks || [];
  const nameFull = [nameFirst, nameLast].filter(Boolean).join(' ');

  return (
    <>
      {hasBeenSubmitted && checks.length > 0 ? (
        <ChecksTable checks={checks} verification={verification} />
      ) : (
        <StyledAttributeGrid>
          <Attribute label='Full name' value={nameFull} redacted={isRedacted} />
          <Attribute label='Birthdate' value={formatDate(birthdate)} redacted={isRedacted} />
        </StyledAttributeGrid>
      )}
    </>
  );
};

export default DatabaseAadhaarVerification;
